export default __webpack_public_path__ + "mytributes/images/obituaries.jpg";